const getInitialState = () => ({
  taskId: '',
  operation: '',
  taskStatus: '',
  reason: '',
  progress: 0,
  data: {},
  singleInterfaceMigration: false,
  networksConfiguration: {},
  alerts: []
});

export default getInitialState;
